var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.25,
    height: 69.5,
    viewBox: "0 0 94.25 69.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_photos_2352027",
    transform: "translate(-2.875 -15.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2248",
    "data-name": "Caminho 2248",
    d: "M14.9,48a5.875,5.875,0,1,0-5.875-5.875A5.882,5.882,0,0,0,14.9,48Zm0-9.75a3.875,3.875,0,1,1-3.875,3.875A3.879,3.879,0,0,1,14.9,38.25Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2249",
    "data-name": "Caminho 2249",
    d: "M97.125,15.25H18.375V23h-7.75v7.75H2.875v54h78.75V77h7.75V69.25h7.75Zm-17.5,17.5V62.515L59.337,44.374,42.205,61.506,28.194,49.23,4.875,65.578V32.75ZM4.875,68.02,28.056,51.77,40.787,62.923,20.961,82.75H4.875ZM23.789,82.75,59.413,47.126,79.625,65.2V82.75ZM87.375,75h-5.75V30.75h-69V25h74.75Zm7.75-7.75h-5.75V23h-69V17.25h74.75Z",
    fill: "#f4f4f4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderPhoto);
export default __webpack_public_path__ + "static/media/placeholder_photo.db91319e96adbfab221e4252bb872bc7.svg";
export { ForwardRef as ReactComponent };